"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GridsService", {
    enumerable: true,
    get: function() {
        return GridsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _viewwebhookmanager = require("~/utils/view-webhook-manager");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let GridsService = class GridsService {
    async gridViewCreate(context, param, ncMeta) {
        var _param_viewWebhookManager;
        var _param_grid_title, _param_req_user, _param_req_user1;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ViewCreateReq', param.grid);
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const model = await _models.Model.get(context, param.tableId, ncMeta);
        // check for duplicated view title
        param.grid.title = (_param_grid_title = param.grid.title) == null ? void 0 : _param_grid_title.trim();
        const existingView = await _models.View.getByTitleOrId(context, {
            titleOrId: param.grid.title,
            fk_model_id: param.tableId
        }, ncMeta);
        if (existingView) {
            _catchError.NcError.get(context).duplicateAlias({
                type: 'view',
                alias: param.grid.title,
                label: 'title',
                base: context.base_id,
                additionalTrace: {
                    table: param.tableId
                }
            });
        }
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(param.tableId)).forCreate();
        const { id } = await _models.View.insertMetaOnly(context, {
            view: _extends({}, param.grid, {
                // todo: sanitize
                fk_model_id: param.tableId,
                type: _nocodbsdk.ViewTypes.GRID,
                base_id: model.base_id,
                source_id: model.source_id,
                created_by: (_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id,
                owned_by: param.ownedBy || ((_param_req_user1 = param.req.user) == null ? void 0 : _param_req_user1.id)
            }),
            model,
            req: param.req
        }, ncMeta);
        // populate  cache and add to list since the list cache already exist
        const view = await _models.View.get(context, id, ncMeta);
        await _NocoCache.default.appendToList(context, _globals.CacheScope.VIEW, [
            view.fk_model_id
        ], `${_globals.CacheScope.VIEW}:${id}`);
        let owner = param.req.user;
        if (param.ownedBy) {
            owner = await _models.User.get(param.ownedBy);
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.GRID_CREATE, {
            view,
            req: param.req,
            owner,
            context
        });
        await view.getView(context);
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_create',
                payload: view
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return view;
    }
    async gridViewUpdate(context, param, ncMeta) {
        var _param_viewWebhookManager;
        var _param_req_user;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/GridUpdateReq', param.grid);
        const view = await _models.View.get(context, param.viewId, ncMeta);
        if (!view) {
            _catchError.NcError.viewNotFound(param.viewId);
        }
        const oldGridView = await _models.GridView.get(context, param.viewId, ncMeta);
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(param.viewId)).forUpdate();
        await _models.GridView.update(context, param.viewId, param.grid, ncMeta);
        let owner = param.req.user;
        if (view.owned_by && view.owned_by !== ((_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id)) {
            owner = await _models.User.get(view.owned_by, ncMeta);
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.GRID_UPDATE, {
            view,
            gridView: param.grid,
            oldGridView,
            req: param.req,
            owner,
            context
        });
        await view.getView(context);
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_update',
                payload: view
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return view;
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
GridsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], GridsService);
